import { FooterButton } from "../FooterButton";
import type { FooterBarItem } from "./footerPinning";

/**
 * Бутонът под показалеца по време на влачене (съдържанието на DragOverlay):
 * изглежда като в лентата, за да се види какво ще се получи. Копието е
 * винаги под показалеца, затова пускането пада върху него: бутонът вътре е
 * прозрачен за показалеца — при недостъпно действие той е disabled, а върху
 * disabled бутон браузърът не праща mouseup и влаченето увисва.
 */
export const FooterDragPreview = ({ item }: { item: FooterBarItem }) => (
  <div className="flex h-full w-full cursor-grabbing items-center justify-center [&_*]:pointer-events-none">
    <div className="rounded-[13px] bg-pos-card shadow-[0_14px_32px_rgba(60,40,20,.28)]">
      <FooterButton {...item.button} />
    </div>
  </div>
);
